<template>
    <div style="background:#f0f0f0">
        <Header/>
        <!-- <Nav :list="headerList"/> -->
        <div class="middle-content" style="margin-top:20px">
            <div class="header-title">{{status==='search'?'报名参加活动':'您的资料已经提交成功，请于三个工作日之后查看审核结果！'}}</div>
            <div v-if="status==='search'" class="header-title" style="font-size: 16px;color: #333333;margin-bottom:20px;font-weight: 400;font-family: PingFangSC-Regular;">参加活动需要获取资格</div>
            <div v-if="status!=='search'" class="result" style="padding-left: 512px;">
                <div class="btn result-btn" @click="status='search'" style="margin-left:20px">返回
                </div>
            </div>
            <div v-if="status==='search'" class="form-body" style="padding-left: 413px;">
                <div class="form-group">
                    <label class="control-label"><span>姓</span><span style="display:inline-block;margin-left: 30px;">名</span></label>
                    <input v-model="realname" class="input-large" type="text" autocomplete="off" >
                </div>
                <div class="form-group">
                    <label class="control-label"><span>手</span><span style="display:inline-block;margin-left: 30px;">机</span></label>
                    <input v-model="phone" class="input-large" type="text" autocomplete="off">
                </div>
                <div class="form-group">
                    <label class="control-label"><span>邮</span><span style="display:inline-block;margin-left: 30px;">箱</span></label>
                    <input v-model="email" class="input-large" type="text" autocomplete="off">
                </div>
                <div class="form-group" style="position:relative">
                    <label class="control-label">IFM级别</label>
                    <input v-model="selectLabel" readonly class="input-large" type="text" autocomplete="off" style="cursor:pointer" @click="changeShowList">
                    <div v-if="showList" class="ul-list">
                        <div @click="selectLevel('初级国际财务管理师',0)">初级国际财务管理师</div>
                        <div @click="selectLevel('助理级国际财务管理师',1)">助理级国际财务管理师</div>
                        <div @click="selectLevel('国际财务管理师',2)">国际财务管理师</div>
                        <div @click="selectLevel('高级国际财务管理师',3)">高级国际财务管理师</div>
                    </div>
                </div>
                
                <div class="btn" @click="next">提交
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState([
    ]),
    components:{
    },
    data() {
        return {
            headerList:[
                {name:'首页', href:'/'},
                {name:'成绩查询', href:'/'},
            ],
            status:'search',
            realname:'',
            phone:'',
            email:'',
            level:'',
            selectLabel:'',
            showList: false,
        }
    },
    mounted(){
    },
    methods: {
        async next(){
            if(this.realname === ''){
                this.$toast('请输入姓名');
                return false;
            }
            if(this.phone === ''){
                this.$toast('请输入手机号');
                return false;
            }
            if(this.email === ''){
                this.$toast('请输入邮箱');
                return false;
            }
            if(this.level === ''){
                this.$toast('请选择IFM级别');
                return false;
            }
            try {
                const res = await this.$http.post('/api/user/applyActivity',{realname:this.realname,phone:this.phone,email:this.email,level:this.level,activity_id:this.$route.query.id});
                res&&(this.status = 'result');
            } catch (error) {
                this.$toast(error.message||'请求失败');
            }
        },
        changeShowList(){
            this.showList = !this.showList;
            console.log(this.showList);
        },
        selectLevel(label, level){
            this.selectLabel = label;
            this.level = level;
            this.showList = false;
        }
    },
}
</script>
<style lang="scss" scoped>
.middle-content{
    width: 1120px;
    margin: auto;
    background: #fff;
    box-sizing: border-box;
    padding: 30px 0 47px 0;
    margin-bottom: 22px;
    .header-title{
        font-family: PingFangSC-Semibold;
        font-size: 22px;
        color: #235483;
        letter-spacing: 0.62px;
        font-weight: 600;
        text-align: center;
        margin-bottom: 25px;
    }
}
.btn{
    padding: 9px 24px;
    display: inline-block;
    margin-left: 102px;
    margin-top: 42px;
    cursor: pointer;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0.45px;
    font-weight: 600;
    font-family: PingFangSC-Semibold;
    background: #A4204F;
}
.result{
    font-size: 16px;
    color: #333333;
    letter-spacing: 0.45px;
    font-weight: 400;
    div{
        margin-bottom:15px;
    }
}
.input-large{
    margin-left: 10px;
}
.result-btn{
    background: #FFFFFF;
    border: 1px solid #979797;
    color: #333333;
}

.ul-list{
    position: absolute;
    left: 111px;
    background: #fff;
    border: 1px solid #e5e0e0;
    border-bottom:0px;
    div{
        padding:10px;
        border-bottom: 1px solid #e5e0e0;
        cursor: pointer;
    }
}
</style>
